import { CommonModule } from '@angular/common';
import { Injectable, NgModule } from '@angular/core';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { InternalServerErrorComponent } from './internal-server-error/internal-server-error.component';
import { LoggedOutComponent } from './logged-out/logged-out.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { UiCommonModule } from '@widgets/ui-common/ui.common.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [AccessDeniedComponent, InternalServerErrorComponent, LoggedOutComponent, PageNotFoundComponent],
  imports: [UiCommonModule, RouterModule],
  exports: [AccessDeniedComponent, InternalServerErrorComponent, LoggedOutComponent, PageNotFoundComponent]
})
export class ErrorPagesModule {}
